module.exports = __webpack_public_path__ + "img/20.ce3666a2.png";